import Vue from 'vue'
import Vuex from 'vuex'
import { UserState } from './modules/user'
import { AppState } from './modules/app'
import { TagsViewState } from './modules/tags-view'

Vue.use(Vuex)

export interface RootState {
  user: UserState
  app: AppState
  tagsView: TagsViewState
}

export default new Vuex.Store<RootState>({})

// export default new Vuex.Store({
//   state: {},
//   mutations: {},
//   actions: {},
//   modules: {
//   }
// })
